import React from 'react';
import appliances from '../../assets/images/resources/appliances.png';
import furniture from '../../assets/images/resources/furniture.png';
import junk from '../../assets/images/resources/junk.png';
import renovation from '../../assets/images/resources/renovation.png';
import cleanout from '../../assets/images/resources/cleanout.png';
import hoarding from '../../assets/images/resources/hoarding.png';
import construction from '../../assets/images/resources/construction.png';
import business from '../../assets/images/resources/business.png';

const ServiceCard = ({ title, description, imageSrc }) => {
    return (
        <div className='row' style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px 20px', 
            position: 'relative', // Add position relative to handle absolute positioning of the yellow background
        }}>
            
            {/* Image element */}
            <div style={{ position: 'relative', width: '100%', maxWidth: '300px', height: 'auto' }}>
                <img 
                    src={imageSrc} 
                    alt={title} 
                    style={{
                        width: '100%', 
                        height: 'auto', 
                        display: 'block', 
                        marginBottom: '10px',
                        position: 'relative',
                        zIndex: 1,
                    }} 
                />
                {/* Pseudo element to create 80% yellow border */}
                <div style={{
                    content: '""',
                    position: 'absolute',
                    bottom: '0', 
                    right: '5px', // Move the right border 5px to the left
                    width: '80%',
                    height: '80%',
                    borderBottom: '10px solid rgb(251, 225, 8)', 
                    borderRight: '10px solid rgb(251, 225, 8)', 
                    zIndex: 0,
                }} />
            </div>

            {/* Title element */}
            <h3 style={{
                color: "#4E4E4E",
                fontFamily: "'Oswald', sans-serif",
                fontSize: "22px", 
                fontWeight: 600,
                textTransform: "uppercase",
                margin: '10px 0', 
                textAlign: 'center',
                zIndex: 1, // Ensures the title is above the yellow background
            }}>
                {title}
            </h3>

            {/* Description element */}
            <p style={{
                fontSize: '1.19rem', 
                color: '#555',
                textAlign: 'center',
                lineHeight: '1.4', 
                margin: '0',
                fontWeight: 400,
                zIndex: 1, // Ensures the description is above the yellow background
            }}>
                {description}
            </p>
        </div>
    );
};

const ServicesSection = () => {
    const services = [
        {
            title: "Appliances",
            description: "Remove old appliances and dispose of them properly.",
            imageSrc: appliances,
        },
        {
            title: "Furniture",
            description: "Remove unwated furniture without the hassle.",
            imageSrc: furniture,
        },
        {
            title: "Just Junk",
            description: "We'll take care of your junk so you don't have to.",
            imageSrc: junk,
        },
        {
            title: "Renovations",
            description: "Remove construction debris and waste from your renovation project.",
            imageSrc: renovation,
        },
        {
            title: "Property Clean Outs",
            description: "We'll clean out your entire property and dispose of everything.",
            imageSrc: cleanout,
        },
        {
            title: "Hoarding Situations",
            description: "We're experienced in handling hoarding situations.",
            imageSrc: hoarding,
        },
        {
            title: "Construction Debris",
            description: "Remove construction debris and waste from your renovation project.",
            imageSrc: construction,
        },
        {
            title: "Commercial/Business",
            description: "We offer junk removal services for businesses.",
            imageSrc: business,
        },
    ];

    return (
        <section style={{ padding: '20px', backgroundColor: '#F9F9F9', margin: '0' }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '0px',
                maxWidth: '1200px',
                margin: '0 auto',
            }}>
                {services.map((service, index) => (
                    <ServiceCard 
                        key={index} 
                        title={service.title} 
                        description={service.description} 
                        imageSrc={service.imageSrc} 
                    />
                ))}
            </div>
        </section>
    );
};

export default ServicesSection;
